import React from 'react';

const CurrentCompanyContext = React.createContext({ currentCompany: '', handleSetCompany: () => {} });

export default CurrentCompanyContext;
